import React, { useEffect, useContext } from 'react';
import { HrFlexContainer, HrGrey, HrTitleContainer, HrTitleH4, HrTitleH6 } from '@components/styles/hr-styles';
import { useMutation } from '@tanstack/react-query';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { vacancyRequirementType } from '../../../constant/vacancy-requirement';
import { getCountries } from '../../../crud_vacancy/services/api-hiringroom';
import { getBunAreas, getBunSubAreas, getIndustries, getSeniorities } from '../../services/api';
import useStore from '../../store/useStore';
import { SectionPost } from './posts';
import { DisplaySettingsContext } from '../../store/display-settings';

export const ControllerPost = observer(
  ({ vacancyRequirement, register, formState, control, getValues, setValue, unregister, postulant, action }) => {
    const [t] = useTranslation();
    const {
      countries,
      seniorities,
      bunAreas,
      bunSubAreasAll,
      setBunSubAreas,
      filterSubAreas,
      industries,
      setDataObs,
      setCountries
    } = useStore();

    const _getCountries = useMutation(getCountries, { onSuccess: (data) => setCountries(data.data.response) });
    const _getBunSubAreas = useMutation(getBunSubAreas, { onSuccess: (data) => setBunSubAreas(data.data.response) });
    const _getBunAreas = useMutation(getBunAreas, {
      onSuccess: (data) => setDataObs(data.data.response.area, 'bunAreas')
    });
    const _getSeniorities = useMutation(getSeniorities, {
      onSuccess: (data) => setDataObs(data.data.response.seniority, 'seniorities')
    });
    const _getIndustries = useMutation(getIndustries, {
      onSuccess: (data) => setDataObs(data.data.response.industria, 'industries')
    });

    useEffect(() => {
      if (seniorities.length === 0) _getSeniorities.mutate();
      if (countries.length === 0) _getCountries.mutate();
      if (bunAreas.length === 0) _getBunAreas.mutate();
      if (bunSubAreasAll.length === 0) _getBunSubAreas.mutate();
      if (industries.length === 0) _getIndustries.mutate();
    }, []);

    const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

    return (
      <HrFlexContainer flexDirection='column' alignItems='flex-start'>
        {/* EDUCACION */}
        <HrTitleContainer flexWrap='wrap' borderBottom={darkMode ? '1px solid #767676' : ''} >
          <HrTitleH4 fontSizeSetting={fontSizeSetting}  color={darkMode ? 'white' : ''} isRequired={vacancyRequirement.jobs === vacancyRequirementType.mandatory}>
            {t('postulant.post.title')}
          </HrTitleH4>
          {vacancyRequirement.jobs === vacancyRequirementType.mandatory && (
            <HrTitleH6 fontSizeSetting={fontSizeSetting}  color={darkMode ?  '#DADADA' : HrGrey}>{t('postulant.post.obligatory')}</HrTitleH6>
          )}
        </HrTitleContainer>

        <SectionPost
          postulant={postulant}
          vacancyRequirement={vacancyRequirement}
          bunAreas={bunAreas}
          countries={countries}
          seniorities={seniorities}
          industries={industries}
          bunSubAreas={bunSubAreasAll}
          filterSubAreas={filterSubAreas}
          register={register}
          control={control}
          formState={formState}
          setValue={setValue}
          getValues={getValues}
          unregister={unregister}
          action={action}
        />
      </HrFlexContainer>
    );
  }
);
